/**
 * Created by Jerker Nord on 2023-06-10.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Loner} from "../../Loner";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {LonerGameMode} from "../../server/LonerGameMode";
import {LonerSound} from "../../sound/LonerSound";
import {gsap} from "gsap";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {LonerGameAssets} from "../../LonerGameAssets";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";

export class LonerMaxWinView extends PIXI.Container implements StageLayer {

    private _button:ContinueButton;
    private _buttonClickCallback:Function;
    private _maxWinMulti:PIXI.Sprite;
    private _flickerTL:gsap.core.Timeline;

    constructor() {
        super();
        this.init();
    }

    private init(): void {
        this._maxWinMulti = new PIXI.Sprite(Loner.assetLoader.getTextures(LonerGameAssets.MAX_WIN_MULTI)[0]);
        this._maxWinMulti.anchor.set(0.5, 0.5);
        this._maxWinMulti.position.set(360, 340);
        this.addChild(this._maxWinMulti);

        this._flickerTL = gsap.timeline({repeat : -1, paused : true});
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.01, 2)}));
        this._flickerTL.add(() => {
            this._maxWinMulti.alpha = MathHelper.randomNumberInRange(0.3, 1, 2);
        });
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.01, 2)}));
        this._flickerTL.add(() => {
            this._maxWinMulti.alpha = MathHelper.randomNumberInRange(0.3, 1, 2);
        });
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.01, 2)}));
        this._flickerTL.add(() => {
            this._maxWinMulti.alpha = MathHelper.randomNumberInRange(0.3, 1, 2);
        });
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.01, 2)}));
        this._flickerTL.add(() => {
            this._maxWinMulti.alpha = MathHelper.randomNumberInRange(0.3, 1, 2);
        });
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.01, 2)}));
        this._flickerTL.add(() => {
            this._maxWinMulti.alpha = MathHelper.randomNumberInRange(0.3, 1, 2);
        });
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.01, 2)}));
        this._flickerTL.add(() => {
            this._maxWinMulti.alpha = MathHelper.randomNumberInRange(0.3, 1, 2);
        });

        this._button = new ContinueButton();
        this._button.addClickCallback(() => this.onButtonClick());
        this._button.pivot.set(this._button.width * 0.5, this._button.height * 0.5);
        this._button.enable(false);
        this.visible = false;
        this.addChild(this._button);

        this.onResize();
    }

    public getMaxWinTL(buttonCallback:Function):gsap.core.Timeline {
        this._buttonClickCallback = buttonCallback;
        const maxWinTL:gsap.core.Timeline = gsap.timeline();
        maxWinTL.add(() => Loner.keypadPlugin.setZeroBetSpinCounter(-1));
        maxWinTL.add(() => {
            this.visible = true;
            Loner.keypadPlugin.setWin(Loner.model.gameData.accumulatedRoundWin, false, Loner.isWinBelowStake());
            this.playMaxWinLoop();
            this._flickerTL.restart();
        });
        maxWinTL.to(this._button, {
            duration : 1,
            alpha : 1
        });
        maxWinTL.add(() => {
            this._button.enable(true);
        });

        return maxWinTL;
    }

    protected playMaxWinLoop():void {
        Loner.soundPlayer.playSound(LonerSound.GM_WIN_LOOP, 1, Number.MAX_VALUE);
        Loner.foregroundView.setMode(LonerGameMode.MAX_WIN);
    }

    public endMaxWin():void {
        Loner.soundPlayer.switchMusic(LonerGameMode.NORMAL);
        Loner.soundPlayer.fadeMusic(0, 1, 1500);
        Loner.soundPlayer.stopSound(LonerSound.GM_WIN_LOOP);
        this._button.enable(false);
        this.visible = false;
        Loner.foregroundView.clearAnimationTrack(0);
        Loner.allReelView.visible = true;
    }

    public onResize() {
        const bounds:ScreenBounds = NolimitApplication.screenBounds;

        //Copied from Launcher/GameIntroView, so we get consistent placement of buttons
        if(NolimitApplication.isLandscape) {
            this._button.position.set(360, 615);
        } else {
            const centerBottom = (bounds.bottom - 610) * 0.5 + 610;
            this._button.position.set(360, centerBottom - 80);
        }
    }

    private onButtonClick():void {
        this._button.enable(false);
        Loner.soundPlayer.playSound(LonerSound.GM_BACK_TO_MAIN_GAME);
        this._flickerTL.pause();
        this._buttonClickCallback();
    }
}